import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../../services/api.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit {
    forgotForm: FormGroup;
    clicked: boolean;

    constructor(private formBuilder: FormBuilder, private router: Router, private toastService: ToastrService,
                public apiService: ApiService) {
    }

    ngOnInit() {
        this.forgotForm = this.formBuilder.group({
            'email': ['', Validators.compose([Validators.required])]
        });
        this.clicked = false;
    }

    public onSubmit(): void {
        if (this.forgotForm.valid) {
            this.clicked = true;
            this.apiService.forgotPassword(this.forgotForm.value['email']).subscribe(data => {
                if (data.statusCode == 200) {
                    this.closeModal();
                    this.toastService.success('Check email to reset password');
                    this.clicked = false;
                } else {
                    this.toastService.error('Email Id not found');
                    this.clicked = false;
                }
            });
        }
    }

    closeModal() {
        let modal = document.querySelector('.login-modal') as HTMLElement;
        if (modal) {
            modal.click();
        }
    }
}
